import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  TabPane,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
} from "reactstrap";
// import BasicDetails from './AttendanceProfile/BasicDetails';
// import StudentDemo from './AttendanceProfile/StudentDemo';
// import Classes from './AttendanceProfile/Classes'
// import Payments from './AttendanceProfile/Payments';
import parentsModal from "models/parents.modal";
import { helper } from "lib/helper";

const InterViewDetails = () => {
  const [activeTab, setActiveTab] = useState("Basicdetails");

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  const getTabContentStyle = (tabId) => {
    return {
      display: activeTab === tabId ? "block" : "none",
      transition: "height 0.3s ease-in-out",
      overflow: "hidden",
    };
  };

  const [dataList, setDataList] = useState([]);
  const location = useLocation();
  const params = useParams();

  const getListData = async () => {
    // Dummy data to replace API call
    const dummyData = [
      {
        id: "1",
        name: "John Doe",
        qualification: "B.Tech CSE Pursuing M.Tech",
        experience: "3 years",
        subjects: ["Math", "Physics", "Chemistry"],
        boards: ["CBSE", "ICSE"],
        communication: "Good",
        availability: true,
        confidence: true,
        qualified: true
      },
      {
        id: "2",
        name: "Jane Smith",
        qualification: "M.Sc Mathematics",
        experience: "5 years",
        subjects: ["Math", "Science"],
        boards: ["CBSE", "State Board"],
        communication: "Excellent",
        availability: true,
        confidence: true,
        qualified: true
      }
    ];
    
    setTimeout(() => {
      setDataList(dummyData);
    }, 500);
  };

  useEffect(() => {
    getListData();
  }, [location, params?.id]);
  console.log(dataList, "ksjdfjkd");

  const [ratings, setRatings] = useState({});

  // Function to handle rating change
  const handleRatingChange = (name, rating) => {
    setRatings({
      ...ratings,
      [name]: rating, // Set the rating for the corresponding name
    });
  };

  return (
    <Container className=" py-7">
      <Card className="shadow mt-1">
        <CardBody className="p-1">
          <div className="container ">


            {/* <div > */}
            <div className="col-12  px-0" id="v-pills-tabContent" style={{}}>
              <div className="mt-2">
                <Container>
                  <Row>
                    <div className="col">
                      <Card className="shadow">
                        <CardHeader className="border-0 d-flex justify-content-between ">
                          <h3 className="mb-0">EXP. WITH BOARD OF Student</h3>
                        </CardHeader>
                        <CardBody>
                          <FormGroup>
                            {["MPBOARD", "CBSE", "ICSE", "NO EXPERIENCE"].map(
                              (name, index) => (
                                <div key={index} className="mb-2 pl-3">
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                    //   checked={checkedItems[name] || false} // Set checked status based on state
                                    //   onChange={() => handleCheckboxChange(name)} // Call handleCheckboxChange on change
                                    />
                                    {name}
                                  </Label>
                                </div>
                              )
                            )}
                          </FormGroup>
                        </CardBody>
                      </Card>
                    </div>
                  </Row>
                </Container>
              </div>

              <div className="mt-2">
                <Container>
                  <Row>
                    <div className="col">
                      <Card className="shadow">
                        <CardHeader className="d-flex justify-content-between ">
                          <h3 className="mb-0">CONCEPT GRIP</h3>
                        </CardHeader>
                        <CardBody>
                          <Row>
                            <Col mb={2}>
                            </Col>
                            <Col mb={10}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div

                                >
                                  <span>Below Average</span>
                                </div>
                                <div>
                                  <span>Average</span>
                                </div>
                                <div>
                                  <span>Good</span>
                                </div>
                                <div>
                                  <span>Excelient</span>
                                </div>
                              </div>
                            </Col>
                          </Row>




                          {[
                            "Maths Concepts",
                            "Science Concepts",
                            "Cross question Concepts",
                          ].map((name, index) => (
                            <Row>
                              <Col mb={2}>

                                <p >{name}</p>


                              </Col>
                              <Col mb={10}>
                                <div style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                }}>
                                  <Label
                                    check
                                    className="ml-5"

                                  >
                                    <Input
                                      type="radio"
                                      name={`radio_${index}`}
                                      style={{ height: "20px", width: "20px" }}
                                    />
                                  </Label>
                                  <Label
                                    check
                                    // className="mr-3"
                                    className="ml-3"

                                  >
                                    <Input
                                      type="radio"
                                      name={`radio_${index}`}
                                      style={{ height: "20px", width: "20px" }}
                                    />
                                  </Label>
                                  <Label
                                    check
                                  // className="mr-1"
                                  >
                                    <Input
                                      type="radio"
                                      name={`radio_${index}`}
                                      style={{ height: "20px", width: "20px" }}
                                    />
                                  </Label>

                                  <Label check>
                                    <Input
                                      type="radio"
                                      name={`radio_${index}`}
                                      style={{ height: "20px", width: "20px" }}
                                    />
                                  </Label>
                                </div>

                              </Col>

                            </Row>
                          ))}

                        </CardBody>
                      </Card>
                    </div>
                  </Row>
                </Container>
              </div>

              <div className="mt-2">
                <Container>
                  <Row>
                    <div className="col">
                      <Card className="shadow">
                        <CardHeader className="border-0 d-flex justify-content-between ">
                          <h3 className="mb-0">QUALIFICATION</h3>
                        </CardHeader>
                        <CardBody>
                          <Label>B.TECH CSE Pursuing M.Tech</Label>
                        </CardBody>
                      </Card>
                    </div>
                  </Row>
                </Container>
              </div>

              <div className="mt-2">
                <Container>
                  <Row>
                    <div className="col">
                      <Card className="shadow">
                        <CardHeader className="border-0 d-flex justify-content-between ">
                          <h3 className="mb-0">SUBJECT COMMAND</h3>
                        </CardHeader>
                        <CardBody>
                          <FormGroup>
                            {[
                              "Math",
                              "Science (6th - 8th)",
                              "Physics (11th - 12th)",
                              "Chemistry (11th - 12th)",
                              "Biology (11th - 12th)",
                              "Social Studies",
                              "Account (11th - 12th)",
                              "Econnomic (11th - 12th)",
                              "Business Studies (11th - 12th)",
                              "Engilsh",
                              "Other",
                            ].map((name, index) => (
                              <div key={index} className="mb-2 pl-3">
                                <Label check>
                                  <Input
                                    type="checkbox"
                                  //   checked={checkedItems[name] || false} // Set checked status based on state
                                  //   onChange={() => handleCheckboxChange(name)} // Call handleCheckboxChange on change
                                  />
                                  {name}
                                </Label>
                              </div>
                            ))}
                          </FormGroup>
                        </CardBody>
                      </Card>
                    </div>
                  </Row>
                </Container>
              </div>

              <div className="mt-2">
                <Container>
                  <Row>
                    <div className="col">
                      <Card className="shadow">
                        <CardHeader className="d-flex justify-content-between ">
                          <h3 className="mb-0">ENGLISH COMMUNICATION</h3>
                        </CardHeader>
                        <CardBody>
                          <p style={{ fontWeight: "bold" }}>
                            Introduction of candidate in terms of english
                            communication
                          </p>
                          <FormGroup className="p-0 col-4">
                            <Label for="exampleEmail">Select </Label>
                            <Input id="forType" name="forType" type="select">
                              <option value="driver">Select </option>
                              <option value="tutor">Tutor</option>
                              <option value="student">Student</option>
                            </Input>
                          </FormGroup>

                          <p style={{ fontWeight: "bold" }}>
                            Communication Skills : overall interaction with
                            candidate
                          </p>
                          <FormGroup className="p-0 col-4">
                            <Label for="exampleEmail">Select </Label>
                            <Input id="forType" name="forType" type="select">
                              <option value="driver">Select </option>
                              <option value="tutor">Tutor</option>
                              <option value="student">Student</option>
                            </Input>
                          </FormGroup>
                        </CardBody>
                      </Card>
                    </div>
                  </Row>
                </Container>
              </div>

              <div className="mt-2">
                <Container>
                  <Row>
                    <div className="col">
                      <Card className="shadow">
                        <CardHeader className="border-0 d-flex justify-content-between ">
                          <h3 className="mb-0">BARRIER</h3>
                        </CardHeader>
                        <CardBody>
                          <p style={{ fontWeight: "bold" }}>
                            (Mention yes or no only)
                          </p>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{ float: "right", marginLeft: "780px" }}
                            >
                              <span>Yes</span>
                            </div>
                            <div>
                              <span>No</span>
                            </div>
                          </div>

                          {[
                            "Is candidate availble after 3:00 p.m to take home tutions",
                            "Is candidate engaged in any self-study or exma preparation",
                            "Was candidate confident  throughout screening round?",
                          ].map((name, index) => (
                            <div
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <span className="d-inline-block">{name}</span>
                              <div className="text-center mb-3">
                                <Label
                                  check
                                  className="mr-3"
                                  style={{ width: "250px", fontSize: "20px" }}
                                >
                                  <Input
                                    type="radio"
                                    name={`radio_${index}`}
                                    style={{ height: "20px", width: "20px" }}
                                  />
                                </Label>
                                <Label check>
                                  <Input
                                    type="radio"
                                    name={`radio_${index}`}
                                    style={{ height: "20px", width: "20px" }}
                                  />
                                </Label>
                              </div>
                            </div>
                          ))}
                        </CardBody>
                      </Card>
                    </div>
                  </Row>
                </Container>
              </div>

              <div className="mt-2">
                <Container>
                  <Row>
                    <div className="col">
                      <Card className="shadow mt-3">
                        <CardHeader className="border-0 d-flex justify-content-between ">
                          <h3 className="mb-0">RESULTS</h3>
                        </CardHeader>
                        <CardBody>
                          <p style={{ fontWeight: "bold" }}>
                            (Mention yes or no only)
                          </p>

                          <div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{ float: "right", marginLeft: "780px" }}
                              >
                                <span>Yes</span>
                              </div>
                              <div>
                                <span>No</span>
                              </div>
                            </div>

                            {[
                              "Did Candidate qualify respective  standard for Math / Science?/",
                            ].map((name, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <span className="d-inline-block">{name}</span>
                                <div className="text-center mb-3">
                                  <Label
                                    check
                                    className="mr-3"
                                    style={{ width: "250px", fontSize: "20px" }}
                                  >
                                    <Input
                                      type="radio"
                                      name={`radio_${index}`}
                                      style={{ height: "20px", width: "20px" }}
                                    />
                                  </Label>
                                  <Label check>
                                    <Input
                                      type="radio"
                                      name={`radio_${index}`}
                                      style={{ height: "20px", width: "20px" }}
                                    />
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="shadow mt-3">
                        <CardBody>
                          <div className="mt-4">
                            <p style={{ fontWeight: "bold" }}>
                              Mention Badge for which candidate was found to be suitable
                            </p>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Row>
                                <Col md={4}></Col>

                                <Col md={8}>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div>
                                      <span>Badge 4th</span>
                                    </div>
                                    <div>
                                      <span>Badge 3rd</span>
                                    </div>
                                    <div>
                                      <span>Badge 2nd</span>
                                    </div>
                                    <div>
                                      <span>Not Found/Applicable</span>
                                    </div>
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                {["Qualified Badge of Candidate"].map(
                                  (name, index) => (
                                    <>
                                      <Col mb={4}>
                                        <span>{name}</span>
                                      </Col>
                                      <Col mb={8}>
                                        <div
                                          className=" mb-3"
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                          }}
                                        >
                                          <Label
                                            check
                                            style={{ marginRight: "-250px" }}
                                          >
                                            <Input
                                              type="radio"
                                              name={`radio_${index}`}
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                            />
                                          </Label>
                                          <Label
                                            check
                                            style={{ marginRight: "160px" }}
                                          >
                                            <Input
                                              type="radio"
                                              name={`radio_${index}`}
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                            />
                                          </Label>
                                          <Label
                                            check
                                            style={{ marginRight: "100px" }}
                                          >
                                            <Input
                                              type="radio"
                                              name={`radio_${index}`}
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                            />
                                          </Label>
                                          <Label
                                            check
                                            style={{ marginRight: "50px" }}
                                          >
                                            <Input
                                              type="radio"
                                              name={`radio_${index}`}
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                            />
                                          </Label>
                                        </div>
                                      </Col>
                                    </>
                                  )
                                )}
                              </Row>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="shadow mt-3">
                        <CardBody>
                          <div className="mt-4">
                            <p style={{ fontWeight: "bold" }}>
                              Mention Segment for Which candidate was found to
                              be Suitable
                            </p>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Row>
                                <Col md={2}></Col>
                                <Col md={10}>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div>
                                      <span>
                                        Per- primary
                                        <br />
                                        (k -2nd)
                                      </span>
                                    </div>
                                    <div>
                                      <span>
                                        Primary <br /> (3-5)
                                      </span>
                                    </div>
                                    <div>
                                      <span>
                                        Lower secondary <br />
                                        (6-8)
                                      </span>
                                    </div>
                                    <div>
                                      <span>
                                        Mid secondary
                                        <br /> (9-10)
                                      </span>
                                    </div>
                                    <div>
                                      <span>
                                        Potential For Hr. sec <br /> (11th-12)
                                      </span>
                                    </div>
                                    <div>
                                      <span>NA</span>
                                    </div>
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                {["Qualified Badge of Candidate"].map(
                                  (name, index) => (
                                    <>
                                      <Col lg={2} key={index}>
                                        <p>{name}</p>
                                      </Col>
                                      <Col mb={10} key={index}>
                                        <div
                                          className="mt-3"
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <Label
                                            check
                                            style={{ marginLeft: "20px" }}
                                          >
                                            <Input
                                              type="radio"
                                              name={`radio_${index}`}
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                            />
                                          </Label>
                                          <Label
                                            check
                                            style={{ marginRight: "20px" }}
                                          >
                                            <Input
                                              type="radio"
                                              name={`radio_${index}`}
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                            />
                                          </Label>
                                          <Label
                                            check
                                            style={{ marginRight: "20px" }}
                                          >
                                            <Input
                                              type="radio"
                                              name={`radio_${index}`}
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                            />
                                          </Label>
                                          <Label
                                            check
                                            style={{ marginRight: "20px" }}
                                          >
                                            <Input
                                              type="radio"
                                              name={`radio_${index}`}
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                            />
                                          </Label>
                                          <Label
                                            check
                                            style={{ marginRight: "20px" }}
                                          >
                                            <Input
                                              type="radio"
                                              name={`radio_${index}`}
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                            />
                                          </Label>
                                          <Label
                                            check
                                            style={{ marginRight: "20px" }}
                                          >
                                            <Input
                                              type="radio"
                                              name={`radio_${index}`}
                                              style={{
                                                height: "20px",
                                                width: "20px",
                                              }}
                                            />
                                          </Label>
                                        </div>
                                      </Col>
                                    </>
                                  )
                                )}
                              </Row>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="shadow mt-3">
                        <CardHeader>
                          <h3 className="mb-0"> REMARKS</h3>
                        </CardHeader>
                        <CardBody>
                          <FormGroup>
                            <Input
                              type="textarea"
                              placeholder="Enter Your Ansawer"
                            />
                          </FormGroup>
                        </CardBody>
                      </Card>
                    </div>
                  </Row>
                </Container>
              </div>

              <div className="mt-2">
                <Container>
                  <Row>
                    <div className="col">
                      <Card className="shadow mt-3">
                        <CardHeader>
                          <h3 className="mb-0">METHODOLOGY/TEACHINGH METHOD</h3>
                        </CardHeader>
                        <CardBody>
                          <div className="mt-4">
                            <p style={{ fontWeight: "bold" }}>
                              (Mention yes or no only)
                            </p>

                            <Row>
                              <Col md={4}></Col>
                              <Col md={8}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div>
                                    <span>Yes</span>
                                  </div>
                                  <div>
                                    <span>No</span>
                                  </div>
                                  <div>
                                    <span>Needs Guidance</span>
                                  </div>
                                </div>
                              </Col>
                            </Row>


                            {[
                              "Did candidate start form basic/scratch to explain",

                              "Did candidate use examples to explain",
                              "Did candidate use Hindi terminologies instead of English terms in explanation?",
                            ].map((name, index) => (
                              <Row>
                                <Col lg={4} key={index}>
                                  <div
                                    className="mt-3"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      // justifyContent: "space-between",
                                    }}
                                  >
                                    {name}
                                  </div>
                                </Col>
                                <Col mb={8} key={index}>
                                  <div
                                    className="mt-4"
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Label
                                      check
                                      className="ml-3"

                                    >
                                      <Input
                                        type="radio"
                                        name={`radio_${index}`}
                                        style={{
                                          height: "20px",
                                          width: "20px",
                                        }}
                                      />
                                    </Label>
                                    <Label
                                      check
                                      className="mr-7"
                                    >
                                      <Input
                                        type="radio"
                                        name={`radio_${index}`}
                                        style={{
                                          height: "20px",
                                          width: "20px",
                                        }}
                                      />
                                    </Label>
                                    <Label
                                      check

                                    >
                                      <Input
                                        type="radio"
                                        name={`radio_${index}`}
                                        style={{
                                          height: "20px",
                                          width: "20px",
                                        }}
                                      />
                                    </Label>
                                  </div>
                                </Col>
                              </Row>
                            ))}

                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </Row>
                </Container>
              </div>
            </div>
            {/* </div> */}
          </div>
        </CardBody>
      </Card>
    </Container>
  );
};

export default InterViewDetails;
